module.exports = __webpack_public_path__ + "static/img/morig.957218f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/teams/img/morig.png
// module id = hlO6
// module chunks = 1